var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-checkbox",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-checkbox1",
    serifid: "iconS-checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6.062l0,11.875c0,1.967 -1.596,3.563 -3.563,3.563l-11.875,0c-1.966,0 -3.562,-1.596 -3.562,-3.563l-0,-11.875c-0,-1.966 1.596,-3.562 3.562,-3.562l11.875,-0c1.967,-0 3.563,1.596 3.563,3.562Zm-2.681,2.639c0.134,-0.134 0.208,-0.318 0.216,-0.522c0.022,-0.513 -0.421,-0.982 -0.946,-0.976c-0.204,0.002 -0.389,0.083 -0.522,0.216l-7.388,7.429l-3.537,-3.537c-0.133,-0.133 -0.318,-0.215 -0.522,-0.216c-0.591,-0.002 -0.955,0.406 -0.947,0.905c0.004,0.204 0.083,0.389 0.217,0.522l4.268,4.297c0.133,0.134 0.318,0.216 0.521,0.216c0.204,0 0.389,-0.082 0.522,-0.216l8.118,-8.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6.062l0,11.876c0,1.966 -1.596,3.562 -3.563,3.562l-11.875,0c-1.966,0 -3.562,-1.596 -3.562,-3.562l-0,-11.876c-0,-1.966 1.596,-3.562 3.562,-3.562l11.875,-0c1.967,-0 3.563,1.596 3.563,3.562Zm-16,2.071c0.202,-0.026 0.413,-0.039 0.631,-0.038c1.028,0.004 1.958,0.421 2.632,1.095l1.41,1.41l5.071,-5.1l-9.182,0c-0.31,0 -0.562,0.252 -0.562,0.562l0,2.071Zm13.319,0.568c0.134,-0.134 0.208,-0.318 0.216,-0.522c0.022,-0.513 -0.421,-0.982 -0.946,-0.976c-0.204,0.002 -0.389,0.083 -0.522,0.216l-7.388,7.429l-3.537,-3.537c-0.133,-0.133 -0.318,-0.215 -0.522,-0.216c-0.591,-0.002 -0.955,0.406 -0.947,0.905c0.004,0.204 0.083,0.389 0.217,0.522l4.268,4.297c0.133,0.134 0.318,0.216 0.521,0.216c0.204,0 0.389,-0.082 0.522,-0.216l8.118,-8.118Zm-11.72,9.799l-1.599,-1.61l0,1.048c0,0.31 0.252,0.562 0.562,0.562l1.037,-0Zm11.401,-5.237l-5.237,5.237l4.675,-0c0.31,-0 0.562,-0.252 0.562,-0.562l-0,-4.675Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSCheckbox);
export default __webpack_public_path__ + "static/media/iconS-checkbox.5a76e8d7b139ed4c23531edde4391b03.svg";
export { ForwardRef as ReactComponent };